import { Fragment, h } from "preact";
import { ITableData } from "../../interface/table";
import { TableComponent } from "../../../../components/table/styled";

export const TableData = ({ columns, data, loading }: ITableData) => {
  return (
    <>
      <TableComponent
        style={{ textAlign: "center" }}
        columns={columns}
        loading={loading}
        dataSource={data}
        bordered
        size="middle"
        scroll={{ x: "max-content" }}
      />
    </>
  );
};
